import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-message-text-square-01',
  standalone: true,
  templateUrl: './rt-icon-message-text-square-01.component.html',
  styleUrls: ['./rt-icon-message-text-square-01.component.scss']
})
export class RtIconMessageTextSquare01Component {
  private readonly defaultConfig = {
    width: 15,
    height: 16
  };

  @Input() width: number | string = this.defaultConfig.width;
  @Input() height: number | string = this.defaultConfig.height;
}
